import * as noUiSlider from 'nouislider/distribute/nouislider.js';

export default {
  init() {
    // JavaScript to be fired on all pages

    // Remove empty nodes
    function clean(node)
      {
        for(var n = 0; n < node.childNodes.length; n ++)
        {
          var child = node.childNodes[n];
          if
          (
            child.nodeType === 8 || (child.nodeType === 3 && !/\S/.test(child.nodeValue))
          )
          {
            node.removeChild(child);
            n --;
          }
          else if(child.nodeType === 1)
          {
            clean(child);
          }
        }
      }
    clean(document);

    // Stop all # links
    $('a[href="#"]').click(function(e){
      e.preventDefault();
    });

    // Show/hide search dropdown
    $('#toggleSearch').on('click', function(){
      $('#searchDropdown').stop().slideToggle();
    });

    // Hide search dropdown
    $('#closeSearch').on('click', function(){
      $('#searchDropdown').stop().slideUp();
    });

    // Hide search when click off
    $(document).mouseup(function(e){
       var menu = $('#searchDropdown');
       if (!menu.is(e.target) // The target of the click isn't the container.
       && menu.has(e.target).length === 0) // Nor a child element of the container
       {
          menu.slideUp();
       }
    });

    // Show hidden search when tapping 'enter' key
    $('#toggleSearch, #closeSearch').keypress(function (e) {
      var key = e.which;
      if(key == 13)  // the enter key code
      {
        $('#searchDropdown').slideToggle();
        return false;
      }
    });

    // Slick settings
    $('.slick-similar').slick({
      infinite: true,
      arrows: true,
      appendArrows: $('.arrows-similar'),
      dots: true,
      slidesToShow: 4,
      slidesToScroll: 4,
    });

    $('.slick-recent').slick({
      infinite: true,
      arrows: true,
      appendArrows: $('.arrows-recent'),
      dots: true,
      slidesToShow: 4,
      slidesToScroll: 4,
    });

    $('.slick-interested').slick({
      infinite: true,
      arrows: true,
      appendArrows: $('.arrows-interested'),
      dots: true,
      slidesToShow: 3,
      slidesToScroll: 3,
    });

    // Initialize multiple select
    $('select.select-standard').multipleSelect({
      labelTemplate: function(el) {
        return '<span></span>' + el.attr('label');
      },
    });

    // Add filter option to multipleSelect with right options set
    $('select.select-with-filter').multipleSelect({
      filter: true,
      labelTemplate: function(el) {
        return '<span></span>' + el.attr('label');
      },
    });

    $('select.select-single-choice').multipleSelect({
      single: true,
      labelTemplate: function(el) {
        return '<span></span>' + el.attr('label');
      },
    });

    initializePeopleInputIncrements();
    initializePriceSlider();

    function initializePriceSlider() {
      let sliderPrice = document.getElementById('slider-price');
      let sliderPriceHeader = document.getElementById('slider-price-header');
      let minPriceInput = document.getElementById('priceMin');
      let maxPriceInput = document.getElementById('priceMax');

      noUiSlider.create(sliderPrice, {
          start: [1500, 3500],
          step: 100,
          range: {
              'min': [+sliderPrice.dataset.min],
              'max': [+sliderPrice.dataset.max],
          },
          tooltips: false,
          connect: [false, true, false],
      });

      let control = sliderPrice.querySelector('.noUi-connect');
      control.style.background = '#0071b6';

      sliderPrice.noUiSlider.on('update', function () {
        let values = sliderPrice.noUiSlider.get()
        sliderPriceHeader.innerHTML = '£' + values[0] + ' to £' + values[1];
        minPriceInput.value = values[0];
        maxPriceInput.value = values[1];
      });
    }

    function initializePeopleInputIncrements() {
      let incrementButtons = document.querySelectorAll('.people-increment');
      let peopleInput = document.querySelector('#people-input')
      if (!incrementButtons) return;
      incrementButtons.forEach(el => {
        el.addEventListener('click', e => {
          if (e.target && e.target.matches('.people-increment-plus')) {
            peopleInput.value = parseInt(peopleInput.value) + 1;
          }
          if (e.target && e.target.matches('.people-increment-minus')) {
            peopleInput.value = parseInt(peopleInput.value) - 1;
          }
        });
      })
    }

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js